import { renderIcon } from '@opallabs/kuiper'

interface AssignmentIconProps {
  className?: string
  iconName?: string
  color?: string
  height?: number
  width?: number
}

export const AssignmentIcon: React.FC<AssignmentIconProps> = ({
  className,
  iconName,
  color,
  height = 14,
  width = 14,
}) =>
  iconName ? (
    <div
      css={[
        {
          display: 'flex',
          position: 'relative',
        },
      ]}
      className={className}
    >
      {renderIcon(iconName, {
        style: { color, height, width },
        ariaMode: 'hidden',
      })}
    </div>
  ) : null
